import { Box, LinearProgress, Typography } from "@mui/material";

const COLORS = [
  "colors.chartOrange", // #EF6721
  "colors.chartYellowOrange", // #EFAF25
  "colors.chartBlue", // #5A92DB
  "colors.chartSlateGray", // #737A83
  "primary.light", // #80BC00
  "colors.chartViolet", // #A259F7
  "colors.chartCoralRed", // #FF6B6B
  "colors.chartTeal", // #00B8A9
];

export default function CropProgressBars({ crops }) {
  const totalValue = crops.reduce((sum, c) => sum + c.value, 0);

  return (
    <>
      {crops.map((crop, idx) => {
        const percent = totalValue > 0 ? (crop.value / totalValue) * 100 : 0;
        const color = COLORS[idx % COLORS.length];

        return (
          <Box
            key={crop.name}
            sx={{
              display: "flex",
              flexDirection: "column",
              mb: 2,
              "&:last-child": { mb: 0 },
              "@media print": {
                mb: 1,
                "&:last-child": { mb: 0 },
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                mb: 0.5,
                "@media print": {
                  mb: 0.25,
                },
              }}
            >
              <Box sx={{ width: 100 }} />
              <Box
                sx={{
                  flex: 1,
                  mx: 2,
                  "@media print": {
                    mx: 1,
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: ".875rem",
                    fontWeight: "800",
                    "@media print": {
                      fontSize: "0.875rem",
                    },
                  }}
                >
                  ${crop.value.toLocaleString()}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: 100 }}>
                <Typography
                  title={crop.name}
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100px",
                    "@media print": {
                      fontSize: "0.875rem",
                      width: "100px",
                    },
                  }}
                >
                  {crop.name}
                </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  mx: 2,
                  "@media print": {
                    mx: 1,
                  },
                }}
              >
                <LinearProgress
                  variant="determinate"
                  value={percent}
                  sx={{
                    height: "1.25rem",
                    borderRadius: "999px",
                    backgroundColor: "colors.borderLightGray",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: color,
                      borderRadius: "999px",
                    },
                    border: "none !important",
                    "@media print": {
                      height: "1rem",
                    },
                  }}
                />
              </Box>
              <Box
                sx={{
                  width: "2rem",
                  textAlign: "right",
                  "@media print": {
                    width: "1.5rem",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "500",
                    "@media print": {
                      fontSize: "0.875rem",
                    },
                  }}
                >
                  {percent.toFixed(0)}%
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      })}
    </>
  );
}
